import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { RenderedSection, SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { Section } from '../../../editor-container/editor-model';
import { Subject, Subscription } from 'rxjs';
import { RowCell } from '@urbannex/storethemes';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { NbDialogService } from '@nebular/theme';
import { takeUntil } from 'rxjs/operators';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';
import { EditState } from '../../../model';

@Component({
  selector: 'kve-category-section-editor',
  templateUrl: './category-section-editor.component.html',
  styleUrls: ['./category-section-editor.component.scss']
})
export class CategorySectionEditorComponent implements OnInit,OnDestroy {
  @Input() selectedSection:Section;
  @Input() selectedRenderedSection:RenderedSection;
  elementId:string;
  gridThumbnails:any[];
  gridThumbnails$:Subscription;
  cellIdsThumbs:any[] = [];
  cellIdsThumbs$:Subscription;
  selectedCell:RowCell;

  @Output() setListMode = new EventEmitter();

  private destroy$: Subject<void> = new Subject<void>();
  
  constructor(private sectionEditorBridge:SectionEditorBridgeService,
    private dialogService: NbDialogService,
    private previewEditStoreService:PreviewEditStoreService) { }

  ngOnInit(): void {
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
    .subscribe((data:any[]) => {
      console.log(`Track ThumbNails: ${data}`)
      this.gridThumbnails = data;
    })
    this.cellIdsThumbs$ = this.sectionEditorBridge.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
    .subscribe((data:any[]) => {
      console.log(`Track Ids: ${data}`)
      this.cellIdsThumbs = data;
    })
  }

  goBack(e){
    this.setListMode.emit();
  }

  open(options:any){
    console.log(options);
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    const cellId = options["cellId"];
    this.previewEditStoreService.setSelectedCell(cellId);
    this.resolveSelectedCell(cellId);
    let component:Type<any> = EditorDialogComponent;
    let title = "Title"
    switch (action) {
      case "image":
        component = EditorDialogComponent;
        title = "Edit Cell"
        break;
    
      default:
        break;
    }
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    let dialogRef = this.dialogService.open(component,{
      context: {
        title: title,
        imgSrc:imgSrc,
        cellId:cellId,
        section:this.selectedSection,
        selectedCell:this.selectedCell,
        dialogWidth:960
      },
    })
    dialogRef.onClose.subscribe((resp:RowCell) => {
      if(resp != undefined){
        console.log(resp);
        console.log(this.cellIdsThumbs);
        const activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if(activeCell != null && activeCell != undefined){
          activeCell.imgSrc = resp.imgSrc;
        }
        this.previewEditStoreService.updateSelectedCell(resp);
        this.previewEditStoreService.updateEditState(EditState.UPDATED)
      }
    })
  }

  resolveSelectedCell(cellId){
    let cells:RowCell[] = this.selectedSection.sectionData.rowOptions.rowCells;
    if(cells != undefined && cells.length > 0){
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
